angular.module('lsnBase.deprecated.models')
  .factory('ApplicationAllowedChangesObjectsModel', ['LsnApplicationAllowedChangesObjectsModelV1',
    function(LsnApplicationAllowedChangesObjectsModelV1) {
      return LsnApplicationAllowedChangesObjectsModelV1;
    }
  ]);